import { useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import { formatApiError } from '@/auth/AuthContext';
import { Seo } from '@/components/site/Seo';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get('token') || '';
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [error, setError] = useState('');
  const [done, setDone] = useState(false);
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (password !== confirm) {
      setError('Passwords do not match.');
      return;
    }
    setLoading(true);
    try {
      await axios.post(`${API}/auth/reset-password`, { token, password });
      setDone(true);
    } catch (err) {
      setError(formatApiError(err, 'Could not reset the password. The link may have expired.'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="min-h-[70vh] flex items-center bg-brand-bone" data-testid="page-reset-password">
      <Seo title="Reset Password | HearthOak Construction" noindex path="/reset-password" />
      <div className="container-x max-w-md py-16">
        <div className="eyebrow mb-3">Account</div>
        <h1 className="h2">Choose a new password</h1>
        {!token && (
          <p className="body mt-4" data-testid="reset-no-token">This reset link is missing its token. Request a new one from the <Link to="/login" className="text-brand-maroon underline underline-offset-4">sign in page</Link>.</p>
        )}
        {token && done ? (
          <div className="mt-6 border border-brand-border bg-brand-boneAlt p-5" data-testid="reset-success">
            <p className="font-sans text-sm text-brand-charcoal">Your password has been updated.</p>
            <Link to="/login" className="btn-primary mt-4 inline-block" data-testid="reset-login-link">Sign in</Link>
          </div>
        ) : token && (
          <form onSubmit={onSubmit} className="mt-8 space-y-4">
            <input type="password" required minLength={8} value={password} onChange={(e) => setPassword(e.target.value)} placeholder="New password (8+ characters)" className="hoc-input" data-testid="reset-password-input" autoFocus />
            <input type="password" required value={confirm} onChange={(e) => setConfirm(e.target.value)} placeholder="Confirm new password" className="hoc-input" data-testid="reset-confirm-input" />
            {error && <p className="font-sans text-sm text-brand-maroon" data-testid="reset-error">{error}</p>}
            <button type="submit" disabled={loading} className="btn-primary w-full" data-testid="reset-submit">
              {loading ? 'Updating…' : 'Update password'}
            </button>
          </form>
        )}
      </div>
    </section>
  );
}
